import React, { useEffect, useState } from "react";
import ShopItem from "./ShopItem";
import NftSelector from "./NftSelector";
import { Link } from "react-router-dom";
import { WalletContext } from "./App";
import ShopBalance from "./ShopBalance";

export default function Shop() {
    const [items, setItems] = useState<string[] | undefined>(undefined);
    const wallet = React.useContext(WalletContext);

    if (wallet.player.selectedNft === -1 && wallet.player.nfts !== undefined && wallet.player.nfts.length > 0) {
        wallet.player.selectedNft = wallet.player.nfts[0].id;
    }

    const loadItems = async (nft: number) => {
        console.log('Loading items for nft ' + nft + '...');
        setItems(undefined);
        let items = await fetch('/.netlify/functions/items?nft=' + nft).then(response => response.json());
        setItems(items);
    }

    const refresh = async () => {
        wallet.player.loadRewards();
        loadItems(wallet.player.selectedNft);
    }

    useEffect(() => {
        loadItems(wallet.player.selectedNft);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className='flexColumn' style={{width: '1008px', padding: '20px', textAlign: 'center'}}>
            <div style={{fontSize: '30px', marginBottom: '20px'}}>Duckracerz Shop</div>
            <NftSelector message={'Select a duck to buy items for'} pagesize={5} selectFn={loadItems}/>
            <div className='flexRow'>
                <ShopItem items={items} id='0101' price={10} rarity='common' name='Cowboy Hat' desc='Shades you from the sun' successFn={refresh}/>
                <ShopItem items={items} id='0101b' price={10} rarity='common' name='Cowboy Hat' desc='Shades you from the sun' successFn={refresh}/>
                <ShopItem items={items} id='0101c' price={10} rarity='common' name='Cowboy Hat' desc='Shades you from the sun' successFn={refresh}/>
            </div>
            <div className='flexRow'>
                <ShopItem items={items} id='0102' price={25} rarity='rare' name='Baseball Cap' desc='Sporty and casual look' successFn={refresh}/>
                <ShopItem items={items} id='0102b' price={25} rarity='rare' name='Baseball Cap' desc='Sporty and casual look' successFn={refresh}/>
                <ShopItem items={items} id='0102c' price={25} rarity='rare' name='Baseball Cap' desc='Sporty and casual look' successFn={refresh}/>
            </div>
            <div className='flexRow'>
                <ShopItem items={items} id='0103' price={100} rarity='epic' name='Top Hat' desc='Race your duck in style' successFn={refresh}/>
                <ShopItem items={items} id='0103b' price={100} rarity='epic' name='Top Hat' desc='Race your duck in style' successFn={refresh}/>
                <ShopItem items={items} id='0103c' price={100} rarity='epic' name='Top Hat' desc='Race your duck in style' successFn={refresh}/>
            </div>
            {/*<ShopCoins/>*/}
            <ShopBalance/>
            <Link to='/'>&lt; back</Link>

        </div>
    );
}
